<template>
  <a-form-item
    v-if="data"
    :label="data.fieldname"
    class="address"
  >
    <div
      v-decorator="[
        fieldkey,
        {
          initialValue: fieldvalue,
          trigger: [],
          rules: [
            {
              required: isneeded,
              message: enterPlaceholder + data.fieldname
            },
            {
              validator: checkValue
            }
          ]
        }
      ]"
      class="wrap"
    >
      <div class="code-line">
        <linkage
          :default-value="routes"
          :get-data="getData"
          :search-data="searchData"
          :report-search="reportSearch"
          :has-child="item => item.haschildren !== 0"
          @change="completeHandle"
        >
          <div class="select-box">
            <a-input
              read-only
              :value="codeDesc"
              :placeholder="placeholder"
              :show-search="showSearch"
            />
            <i
              slot="icon"
              class="iconfont iconicon-test19"
            />
          </div>
        </linkage>
      </div>
      <div>
        <!-- :placeholder="`请输入${data.fieldname}`" -->
        <!-- <a-input
          v-if="enableinput"
          :default-value="fieldvalue.address"
          placeholder="请输入详细地址"
          @change="inputChangeHandle"
        /> -->
      </div>
    </div>
  </a-form-item>
</template>

<script>
import Linkage from '@/components/pc/Linkage'
import { getArea, SearchArea, addAreaSearchLog } from '@/services/index'

export default {
  name: 'Area',
  inject: ['myForm'],
  components: {
    Linkage
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      routes: [],
      visible: false,
      fieldvalue: this.data.fieldvalue || {},
      isneeded: true
    }
  },
  computed: {
    codeDesc () {
      return this.routes.map(item => item.name).join(' / ')
    },
    fieldconfig () {
      const { fieldconfig = {} } = this.data
      return fieldconfig
    },
    enableinput () {
      const { enableinput = true } = this.fieldconfig
      return enableinput
    },
    showSearch () {
      const { showSearch = true } = this.fieldconfig
      return showSearch
    },
    fieldkey () {
      return this.data.fieldkey
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  watch: {
    data: {
      handler (val) {
        this.routes = []
        this.init()
      },
      // deep: true,
      immediate: true
    }
  },
  methods: {
    init () {
      const { fieldvalue = {} } = this.data
      // fix-start: 当fieldvalue为空时后端返回的是[],因此需要下面特殊处理依稀
      // const value = {
      //   code: fieldvalue.code || {}
      // }
      // this.data.fieldvalue = value
      // // fix-end
      // const { code = {} } = this.data.fieldvalue
      this.routes = Object.keys(fieldvalue).map(key => {
        return {
          code: key,
          name: fieldvalue[key]
        }
      })
    },
    checkValue (rule, value = {}, callback) {
      // console.log('arg: ', arguments)
      const { isneeded, enableinput } = this
      if (!isneeded) {
        callback()
      } else {
        // const { code = {}, address = '' } = value
        const { length } = Object.keys(value)
        // console.log('value: ', value)
        // console.log('enableinput: ', enableinput)
        // console.log('length: ', length)
        if (enableinput) {
          if (length) {
            callback()
          } else {
            callback(new Error(`${this.$t('message["865"]')}${this.data.fieldname}`))
          }
        } else {
          if (length) {
            callback()
          } else {
            callback(new Error(`${this.$t('message["855"]')}${this.data.fieldname}`))
          }
        }
      }
    },
    validatedCallback (err, values) {
      if (!err) {
        this.$emit('change', this.fieldvalue)
      }
    },
    inputChangeHandle (e) {
      // console.log('input value: ', e.target.value)
      const { fieldkey, fieldvalue } = this
      // fieldvalue.address = e.target.value
      this.myForm.setFieldsValue({
        [fieldkey]: fieldvalue
      })
      this.myForm.validateFields([fieldkey], this.validatedCallback)
    },
    completeHandle (routes) {
      let { fieldkey, fieldvalue } = this
      // this.routes = routes
      this.routes = routes
      const codes = {}
      routes.forEach((item) => {
        const { code, name } = item
        codes[code] = name
      })
      fieldvalue = codes
      // this.data.defaultValue = codes
      this.$set(this.data, 'defaultValue', codes)
      this.data.fieldvalue = codes
      this.myForm.setFieldsValue({
        [fieldkey]: fieldvalue
      })
      this.myForm.validateFields([fieldkey], this.validatedCallback)
    },

    async getData ({ level, data }) {
      const chain = await getArea()
      const params = {}
      if (data) {
        params.code = data.code
        params.fieldkey = this.data.fieldkey
      } else {
        params.fieldkey = this.data.fieldkey
      }
      return new Promise(async (resolve, reject) => {
        await chain
          .params(params)
          .onSuccess(payload => {
            const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async searchData ({ keyword }) {
      const chain = await SearchArea()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            keyword,
            fieldkey: this.data.fieldkey
          })
          .onSuccess(payload => {
            const arr = payload.map(item => {
              return Object.keys(item).map(code => {
                return {
                  code,
                  name: item[code]
                }
              })
            })
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async reportSearch (value) {
      const chain = await addAreaSearchLog()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            name: value
          })
          .onSuccess(payload => {
            resolve(true)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-box {
  position: relative;
  width: 320px;
  .iconfont {
    position: absolute;
    right: 8px;
    color: $gray3;
  }
}
</style>
<style lang="scss">
.area-pover {
  width: 320px;
  padding-top: 0;
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover-inner-content {
    padding: 0;
  }
}
</style>
